import { createSlice } from "@reduxjs/toolkit";

// Compute last 7 days range
const today = new Date();
const last7Days = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000); // include today

const initialState = {
  startDate: last7Days.toISOString().split("T")[0], // e.g., 2025-09-21
  endDate: today.toISOString().split("T")[0],       // e.g., 2025-09-27
};

export const dateRangeSlice = createSlice({
  name: "dateRange",
  initialState,
  reducers: {
    setDateRange: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setDateRange } = dateRangeSlice.actions;
export default dateRangeSlice.reducer;
